import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import FSObjectUploadStatusListItem from './FSObjectUploadStatusListItem';

function FSObjectUploadStatusList({ statuses }) {
  const items = _.map(statuses, (status, fileName) => {
    return (
      <div key={'file-status-upload-' + fileName}>
        <FSObjectUploadStatusListItem {...{ status, fileName }} />
      </div>
    );
  });

  return <div>{items}</div>;
}

FSObjectUploadStatusList.propTypes = {
  statuses: PropTypes.object.isRequired,
};

export default FSObjectUploadStatusList;
